import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { filter, withLatestFrom, concatMap } from 'rxjs/operators';
import { Action } from 'redux';
import { ReassignSplits } from '../action-creators';
import AppState from '../../state';
import { SplitUpdate } from '@services/ownership/types/split-update';
import { assetOwners } from '@webapp/store/ownership/selectors';
import { ValidOwnershipType } from '@services/ownership/types/valid-ownership-type';
import { LOCATION_CHANGE, LocationChangeAction } from 'connected-react-router';

export const saveAssetOwnershipsEpic = (
  action$: Observable<Action>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Action, LocationChangeAction>(LOCATION_CHANGE),
    withLatestFrom(state$),
    filter(([_, state]) => !!state.ownership.unsavedAssetId),
    concatMap(([_, state]) => {
      const ownershipTypes: ValidOwnershipType[] = ['OWNER', 'WRITER'];
      return ownershipTypes.map((type) => {
        const owners = assetOwners(
          state.ownership,
          state.ownership.unsavedAssetId || '',
          type
        );
        const updates: SplitUpdate[] = Object.values(owners).map((o) => ({
          assetId: o.assetId,
          ownershipId: o.id,
          split: o.split,
        }));
        return new ReassignSplits(
          state.ownership.unsavedAssetId || '',
          type,
          updates,
          []
        );
      });
    })
  );
